import { useEffect, useState } from "react"

/**
 * Turns a fetched Blob into an <img>-usable object URL, revoking the
 * previous one on cleanup/change so callers don't leak blob URLs as the
 * underlying query refetches. Rendering-lifecycle concern, kept out of API
 * hooks themselves (e.g. `useOrgSignatureImage`).
 */
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    if (!blob) {
      setUrl(null)
      return
    }
    const next = URL.createObjectURL(blob)
    setUrl(next)
    return () => URL.revokeObjectURL(next)
  }, [blob])
  return url
}
